<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fBillNo"
        placeholder="单据编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.customer"
        placeholder="客户名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
      >
        <el-table-column prop="fBillType" label="单据类型" width="80px" />
        <el-table-column prop="fBillNo" label="单据编号" width="160px" />
        <el-table-column prop="fDistributor" label="经销商" />
        <el-table-column prop="fCustomer" label="客户名称" />
        <el-table-column label="操作" width="60px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
// import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    // ConfirmButton
  },
  data() {
    return {
      query: {
        fBillNo: null,

        fDistributor: null,
        customer: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
  },
  activated() {
    this.refresh()
    // console.log('来了')
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('OrderManage/Achievement/AchievementEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _view: async function(row) {
      var url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    // console.log(to, "to");
    // console.log(from, "from");
    // console.log(next, "next");
  }
}
</script>
